// R16 version-skew (#deploy-stale-tab): guard consulted by the version-skew
// monitor (src/lib/version-skew) before auto-reloading the SPA onto a new
// build. The app must NEVER reload mid-operation, so "busy" means:
// - the persisted robot-running flag is fresh (written by robot-page-state on
//   every isRunning change, 10-minute freshness window), OR
// - the `tradeKeys.active()` TanStack Query cache (maintained by
//   useActiveTrade's 5 s poll + SSE) holds a trade still in "pending".
// Owned by the robot feature because it composes robot + trade state; the
// shell (app.tsx) injects it via configureVersionSkewReloadGuard — lib/ and
// components/ cannot import features/ under the eslint boundaries rules.
import { tradeKeys } from "@/features/trade/keys";
import type { TradeView } from "@/features/trade";
import { queryClient } from "@/lib/query/client";
import { readPersistedSessionRunning } from "./persisted-session-flag";

export function isTradingActivityInProgress(): boolean {
  if (readPersistedSessionRunning() === true) return true;
  const active = queryClient.getQueryData<TradeView | null>(tradeKeys.active());
  return active?.status === "pending";
}
